import { useDrag } from "react-dnd";
import Badge from "react-bootstrap/Badge";

function WordList(props) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: props.dragType,
    item: { id: props.id },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));
  return (
    <Badge
      pill
      bg="info"
      text="dark"
      ref={drag}
      type={props.type}
      key={props.id}
      id={props.id}
      variant="outline-primary"
      style={{
        marginTop: "5px",
        width: props.width,
        margin: props.margin,
        border: isDragging ? "5px solid #e7b8ff" : "5px solid #0ACDF0",
      }}
    >
      <h1
        style={{
          color: isDragging ? "#e7b8ff" : "#fff",
        }}
      >
        {props.name}
      </h1>
    </Badge>
  );
}
export default WordList;
